import { gradients } from '@components/assets/gradients';
import { StaticImageData } from 'next/image';
import { AWS_BUCKET } from './config';

export type PictureType = 'profile' | 'cover';
export type PictureFormat = 'image' | 'gradient' | 'color' | 'clear';

export function getProjectImageName(type: PictureType, projectId: string) {
  return `${type}-${projectId}`;
}

export function getUserImageName(address: string) {
  return `user-${address}`;
}

export function getProjectImageUrl(options: {
  type: PictureType;
  format: PictureFormat;
  projectId: string;
  value?: string;
}): string {
  const { type, format, projectId, value } = options;

  if (format === 'image')
    return `https://${AWS_BUCKET}.s3.amazonaws.com/${getProjectImageName(type, projectId)}`;
  if (format === 'gradient' && value) return `gradient::${value}`;
  if (format === 'color' && value) return `color::${value.substring(0, 7)}`;
  if (format === 'clear') return ``;

  throw new Error(`Unknown format: ${format}`);
}

export function getUserImageUrl(options: {
  format: PictureFormat;
  address: string;
  value?: string;
}): string {
  const { format, address, value } = options;

  if (format === 'image')
    return `https://${AWS_BUCKET}.s3.amazonaws.com/${getUserImageName(address)}`;
  if (format === 'gradient' && value) return `gradient::${value}`;
  if (format === 'color' && value) return `color::${value.substring(0, 7)}`;
  if (format === 'clear') return ``;

  throw new Error(`Unknown format: ${format}`);
}

export type ParsedImage = {
  imageUrl: string;
  gradient?: {
    name: string;
    direction: string;
    colors: string;
    verison?: string;
  };
  color?: string;
};

// TODO might be easier to put this into its own field in the database instead of overloading the `imageUrl` fields
export function parseImage(imageUrl?: string | StaticImageData | null): ParsedImage {
  const transparentImage =
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';

  if (!imageUrl) return { imageUrl: transparentImage };

  if (typeof imageUrl === 'object') return { imageUrl: transparentImage };

  if (imageUrl.startsWith('gradient::')) {
    const name = imageUrl.split('gradient::')[1];
    return { gradient: gradients.find(g => g.name === name), imageUrl: transparentImage };
  }

  if (imageUrl.startsWith('color::'))
    return { color: imageUrl.split('color::')[1], imageUrl: transparentImage };

  return { imageUrl };
}
